module.exports = __webpack_public_path__ + "static/media/SQSMB.07ca50cd.docx";


//////////////////
// WEBPACK FOOTER
// ./src/authCertificate/modules/attestationType/SQSMB.docx
// module id = 851
// module chunks = 0